import { NOT_LOGGED_IN_USER_ID } from '@ori/auth';

import { PbsCookieNames } from '../models';
import type { AppConfiguration, CookieToTransform } from '../types';

/**
 * Desktop breakpoint
 */
export const DESKTOP_BREAKPOINT = 1024;

/**
/**
 * Default configuration values
 */
export const configurationContextDefaultValues: AppConfiguration = {
  currentLanguage: '',
  customerId: NOT_LOGGED_IN_USER_ID,
  graphqlUrl: '',
  globalApiUrl: '',
  identityUrl: '',
  staticApiUrl: '',
  tenant: '',
  isEnabled: false,
  isTooltipEnabled: false,
};

// The cookies are processed in the order they appear in this array,
// and processing stops at the first found cookie that has stopIfFound == true
export const cookiesToTransform: CookieToTransform[] = [
  {
    cookie: PbsCookieNames.PBS_CODE,
    queryParam: 'store',
    stopIfFound: true,
  },
  {
    cookie: PbsCookieNames.ECREF_OWNER,
    queryParam: 'invite',
    stopIfFound: true,
  },
  {
    cookie: PbsCookieNames.PBS_OWNER,
    queryParam: 'store',
    stopIfFound: false,
  },
  {
    cookie: PbsCookieNames.ECREF,
    queryParam: 'invite',
    stopIfFound: true,
  },
];

export * from './defaultTranslations';
export * from './app';
